<template>
  <div>
    <DataNavigation></DataNavigation>
    <VipPrompt :pageModal="page_modal" @pagecancel="pageCancel"></VipPrompt>
    <div class="index_content">
      <Layout>
        <Sider width="208">
          <div class="right_column">
            <p class="top-tip">医院</p>
            <div class="keyword-input">
              <Input search enter-button :placeholder="search_phd" v-model="search_ipt" @on-search="handleSearch" />
            </div>
            <div class="rigit_title">
              <span>筛选</span>
              <Dropdown trigger="click" placement="bottom-start" @on-visible-change="handleDropdown" @on-click="haddleScreenDropdown">
                <a href="javascript:void(0)">
                  <span>{{screen_active}}</span>
                  <Icon type="md-arrow-dropup" v-if="drop_val" />
                  <Icon type="md-arrow-dropdown" v-else />
                </a>
                <DropdownMenu slot="list">
                  <DropdownItem v-for="(item, sindex) in screen_dropdown" :name="item" :selected="screen_active == item" :key="sindex">{{item}}</DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </div>
            <div class="rigit_content">
              <div class="screen_ul">
                <div class="screen_li" v-show="screen_active === '全部' || screen_active === '定位选择'">
                  <div class="screen_tle" @click="screenTle.hos_tag = !screenTle.hos_tag">
                    <span>标签选择</span>
                    <Icon type="md-add" v-if="!screenTle.hos_tag" />
                    <Icon type="md-remove" v-else />
                  </div>
                  <div class="screen_cnt" v-show="screenTle.hos_tag">
                    <Checkbox v-model="checkAll.hos_tag" class="all_option" :disabled="checkAll.hos_tag" @on-change="handleCheckAll('hos_tag')">
                      <span>不限</span>
                    </Checkbox>
                    <CheckboxGroup v-model="params.hos_tag" @on-change="handleChangeOption($event, 'hos_tag')">
                      <Checkbox v-for="(item,index) in hos_tag" :label="item.id" :key="index" v-show="index < 10 || showAllHosTag">
                        <span>{{item.name}} <template v-if="tagNum.length">({{item.id | dealName(tagNum, 'tag_id', 'num', '0')}})</template></span>
                      </Checkbox>
                    </CheckboxGroup>
                    <span class="more_sel" @click="showAllHosTag = !showAllHosTag" v-show="hos_tag && hos_tag.length > 10">
                      <template v-if="!showAllHosTag">查看更多</template>
                      <template v-else>收起更多</template>
                    </span>
                  </div>
                </div>
                <div class="screen_li" v-show="screen_active === '全部' || screen_active === '医院等级'">
                  <div class="screen_tle" @click="screenTle.hos_level = !screenTle.hos_level">
                    <span>医院等级</span>
                    <Icon type="md-add" v-if="!screenTle.hos_level" />
                    <Icon type="md-remove" v-else />
                  </div>
                  <div class="screen_cnt" v-show="screenTle.hos_level">
                    <Checkbox v-model="checkAll.hos_level" class="all_option" :disabled="checkAll.hos_level" @on-change="handleCheckAll('hos_level')">
                      <span>不限</span>
                    </Checkbox>
                    <CheckboxGroup v-model="params.hos_level" @on-change="handleChangeOption($event, 'hos_level')">
                      <Checkbox v-for="(item,index) in hos_level" :label="item.id" :key="index">
                        <span>{{item.name}} <template v-if="levelNum.length">({{item.id | dealName(levelNum, 'level', 'num', '0')}})</template></span>
                      </Checkbox>
                    </CheckboxGroup>
                  </div>
                </div>
                <div class="screen_li" v-show="screen_active === '全部' || screen_active === '类型选择'">
                  <div class="screen_tle" @click="screenTle.hos_type = !screenTle.hos_type">
                    <span>类型选择</span>
                    <Icon type="md-add" v-if="!screenTle.hos_type" />
                    <Icon type="md-remove" v-else />
                  </div>
                  <div class="screen_cnt" v-show="screenTle.hos_type">
                    <Checkbox v-model="checkAll.hos_type" class="all_option" :disabled="checkAll.hos_type" @on-change="handleCheckAll('hos_type')">
                      <span>不限</span>
                    </Checkbox>
                    <CheckboxGroup v-model="params.hos_type" @on-change="handleChangeOption($event, 'hos_type')">
                      <Checkbox v-for="(item,index) in hos_type" :label="item.id" :key="index" v-show="index < 10 || showAllHosType">
                        <span>{{item.name}} <template v-if="typeNum.length">({{item.id | dealName(typeNum, 'pid', 'num', '0')}})</template></span>
                      </Checkbox>
                    </CheckboxGroup>
                    <span class="more_sel" @click="showAllHosType = !showAllHosType" v-show="hos_type && hos_type.length > 10">
                      <template v-if="!showAllHosType">查看更多</template>
                      <template v-else>收起更多</template>
                    </span>
                  </div>
                </div>
                <div class="screen_li" v-show="screen_active === '全部' || screen_active === '地区选择'">
                  <div class="screen_tle" @click="screenTle.address = !screenTle.address">
                    <span>地区选择</span>
                    <Icon type="md-add" v-if="!screenTle.address" />
                    <Icon type="md-remove" v-else />
                  </div>
                  <div class="screen_cnt" v-show="screenTle.address">
                    <RadioGroup v-model="params.demostic" vertical @on-change="handleChangeDemostic">
                      <Radio :label="null"><span>不限</span></Radio>
                      <Radio :label="0"><span>国外({{foreignNum}})</span></Radio>
                      <div class="sec_options" v-if="params.demostic == 0">
                        <Checkbox v-model="checkAll.address_id" class="all_option" :disabled="checkAll.address_id" @on-change="handleCheckAll('address_id')">
                          <span>全部</span>
                        </Checkbox>
                        <CheckboxGroup v-model="params.address_id" @on-change="handleChangeOption($event, 'address_id')">
                          <Checkbox v-for="(item,index) in foreign_country" :label="item.id" :key="index" v-show="index < 10 || showAllAddress">
                            <span>{{item.name}}</span>
                          </Checkbox>
                        </CheckboxGroup>
                        <span class="more_sel" @click="showAllAddress = !showAllAddress">
                          <template v-if="!showAllAddress">查看更多</template>
                          <template v-else>收起更多</template>
                        </span>
                      </div>
                      <Radio :label="1" class="bro"><span>国内({{chinaNum}})</span></Radio>
                      <div class="sec_options" v-if="params.demostic == 1">
                        <Checkbox v-model="checkAll.address_id" class="all_option" :disabled="checkAll.address_id" @on-change="handleCheckAll('address_id')">
                          <span>全部</span>
                        </Checkbox>
                        <CheckboxGroup v-model="params.address_id" @on-change="handleChangeOption($event, 'address_id')">
                          <Checkbox v-for="(item,index) in city" :label="item.id" :key="index" v-show="index < 10 || showAllAddress">
                            <span>{{item.name}}</span>
                          </Checkbox>
                        </CheckboxGroup>
                        <span class="more_sel" @click="showAllAddress = !showAllAddress">
                          <template v-if="!showAllAddress">查看更多</template>
                          <template v-else>收起更多</template>
                        </span>
                      </div>
                    </RadioGroup>
                  </div>
                </div>
                <div class="screen_li" v-show="screen_active === '全部' || screen_active === '成立时间'">
                  <div class="screen_tle" @click="screenTle.time = !screenTle.time">
                    <span>成立时间</span>
                    <Icon type="md-add" v-if="!screenTle.time" />
                    <Icon type="md-remove" v-else />
                  </div>
                  <div class="screen_cnt" v-show="screenTle.time">
                    <RadioGroup v-model="selTime" vertical @on-change="handleChangeTime">
                      <Radio label=""><span>不限</span></Radio>
                      <Radio v-for="(item, index) in timeOption" :label="item" :key="index">
                        <span>{{item}} <template v-if="yearNum.length">({{item | dealName(yearNum, 'year', 'num', '0')}})</template></span>
                      </Radio>
                      <Radio label="zdy"><span>自定义</span></Radio>
                    </RadioGroup>
                    <div class="zdy_time" v-if="selTime == 'zdy'">
                      <DatePicker type="date" v-model="params.s_time" placeholder="开始时间" :options="startOptions" @on-change="getEntityList" :clearable="false"></DatePicker>
                      <DatePicker type="date" v-model="params.e_time" placeholder="结束时间" :options="endOptions" @on-change="getEntityList" :clearable="false"></DatePicker>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Sider>
        <Content>
          <div class="top-tip">全部<span v-if="!listLoading">（{{total}}）</span>
            <Dropdown @on-click="haddleChangeSort">
              <a href="javascript:void(0)">{{sort_id | dealName(sort_list)}}<i class="iconfont">&#xe6ea;</i></a>
              <DropdownMenu slot="list">
                <DropdownItem v-for="item in sort_list" :key="item.id" :name="item.id" :disabled="sort_id === item.id">{{item.name}}</DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
          <div class="sel_opt" v-if="haveOption && haveOption.length > 0">
            <div class="sel_tle">已选条件</div>
            <div class="sel_cnt">
              <span v-for="(item,index) in haveOption" :key="index" @click="handleCancelOption(item)">{{item.name}}
                <Icon type="md-close" />
              </span>
            </div>
            <div class="sel_clear">
              <span @click="handleClearOption"><i class="iconfont">&#xe63e;</i>清空筛选</span>
            </div>
          </div>
          <div class="list_div">
            <!-- v-if="isVIP || haveOption.length == 0" -->
            <Table :columns="listColumns" :data="listData" :row-class-name="rowClassName">
              <template slot-scope="{ row }" slot="company_name">
                <div class="company">
                  <div class="logo_img" @click="goEntityDetail(row.uid, 3)">
                    <img :src="row.logo_path | logo_show">
                  </div>
                  <div class="company_name" style="width: 232px;">
                    <p><a @click="goEntityDetail(row.uid, 3)">{{row.short_name}}</a></p>
                  </div>
                </div>
                <div class="supply-demand-list" v-if="row.entity_links.length">
                  <div v-for="(demand, dindex) in row.entity_links" :key="dindex" :class="['demand-item', demand.type == 1 && 'green']" @click="goLinkDetail(demand.id)">
                    <i class="iconfont-pc30">&#xe6de;</i>
                    <div class="tag">{{demand.type == 1 ? '需求' : '供给'}}已验证</div>
                    <div class="link-title">{{demand.title}}</div>
                  </div>
                </div>
              </template>
            </Table>
            <SearchPrompt v-if="haveOption && haveOption.length > 0 && !isVIP && listData.length == 5 && total > 5"></SearchPrompt>
            <template v-else>
              <div class="page clear" v-if="total > 10">
                <Page :current="params.page" :total="total" :page-size="10" class="page_list" show-total show-elevator ref="pages" @on-change="handleChangePage" />
              </div>
            </template>
            <Spin fix v-if="listLoading">
              <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
              <div>Loading</div>
            </Spin>
          </div>
        </Content>
      </Layout>
    </div>
  </div>
</template>

<script>
import { hospitalList, hospitalNum } from '../../service'
import { idxOf, remove, removeArrObj } from 'js/findIndex'
import { listMixins } from 'js/listMixins'
import { userInfo } from 'js/userInfo'
import Nothing from '@/components/Nothing.vue'
import DataNavigation from './components/DataNavigation.vue'
import VipPrompt from '@/components/VipPrompt.vue'
import SearchPrompt from './components/SearchPrompt.vue'
import filter from 'js/filter'
import moment from 'moment'

export default {
  inject: ['login'],
  mixins: [listMixins, userInfo],
  components: {
    Nothing,
    DataNavigation,
    VipPrompt,
    SearchPrompt,
  },
  data() {
    return {
      listName: '医院',
      listColumns: [
        {
          title: '医院名称',
          width: 260,
          slot: 'company_name',
        },
        {
          title: '地区',
          width: 160,
          render: (h, params) => {
            return h('span', filter.addressDeal(params.row.address_id, '2'))
          },
        },
        {
          title: '成立时间',
          width: 160,
          render: (h, params) => {
            return h('span', filter.timeTrans(params.row.setup_time))
          },
        },
        {
          title: '等级',
          width: 160,
          render: (h, params) => {
            return h(
              'span',
              filter.hosLevel(params.row.hospital_level1, params.row.hospital_level2)
            )
          },
        },
        {
          title: '类型',
          width: 160,
          render: (h, params) => {
            return h('span', filter.deal(params.row.type_id, 'hospital_type'))
          },
        },
      ],

      params: {
        hos_type: [],
        hos_level: [],
        hos_tag: [],
        demostic: null,
        address_id: [],
        year: '',
        s_time: '',
        e_time: '',
        page: 1,
        user_key: '',
        keyword: '',
        sort_type: 0,
      },
      screen_dropdown: ['全部', '定位选择', '医院等级', '类型选择', '地区选择', '成立时间'],
      //筛选条件是否展开
      screenTle: {
        hos_tag: false,
        hos_type: false,
        hos_level: false,
        address: false,
        time: false,
      },
      //不限
      checkAll: {
        address_id: true,
        hos_type: true,
        hos_level: true,
        hos_tag: true,
      },
      showAllHosType: false,
      showAllHosTag: false,

      chinaNum: 0,
      foreignNum: 0,
      provinceNum: [],
      yearNum: [],
      levelNum: [],
      typeNum: [],
      tagNum: [],
      sort_id: 2,
      sort_list: [
        // {id: 0, name: '默认排序'},
        { id: 2, name: '成立时间倒序' },
        { id: 1, name: '成立时间正序' },
      ],
      position_id: '12',
    }
  },
  computed: {
    hos_type() {
      let hospital_type = this.$store.state.hospital_type,
        h_type = []
      hospital_type.map((a) => {
        if (a.pid == null) h_type.push(a)
      })
      return h_type
    },
    hos_level() {
      return this.$store.state.hos_level
    },
    hos_tag() {
      return this.$store.state.hospital_tag
    },
    haveOption() {
      let optionHosType = [],
        optionHosLevel = [],
        optionHosTag = [],
        optionYear = [],
        optionStart = [],
        opitonEnd = [],
        optionAddressId = [],
        optionKeyWord = [],
        optionDemostic = []

      this.params.hos_type.map((a) => {
        optionHosType.push({
          type: 'hos_type',
          name: filter.deal(a, 'hospital_type'),
          value: a,
        })
      })
      this.params.hos_level.map((a) => {
        optionHosLevel.push({
          type: 'hos_level',
          name: filter.deal(a, 'hos_level'),
          value: a,
        })
      })
      this.params.hos_tag.map((a) => {
        optionHosTag.push({
          type: 'hos_tag',
          name: filter.deal(a, 'hospital_tag'),
          value: a,
        })
      })
      if (this.params.year != '' && this.selTime != 'zdy') {
        optionYear = {
          type: 'year',
          name: this.params.year,
          value: this.params.year,
        }
      }
      if (this.params.s_time != '') {
        optionStart = {
          type: 's_time',
          name: '开始时间：' + filter.time_moment(this.params.s_time),
          value: this.params.s_time,
        }
      }
      if (this.params.e_time != '') {
        opitonEnd = {
          type: 'e_time',
          name: '结束时间：' + filter.time_moment(this.params.e_time),
          value: this.params.e_time,
        }
      }
      if (this.params.demostic !== null) {
        optionDemostic = {
          type: 'demostic',
          name: this.params.demostic == 0 ? '国外' : '国内',
          value: this.params.demostic,
        }
      }
      if (this.params.keyword !== '') {
        optionKeyWord = {
          type: 'keyword',
          name: this.params.keyword,
          value: this.params.keyword,
        }
      }
      this.params.address_id.map((a) => {
        optionAddressId.push({
          type: 'address_id',
          name: filter.deal(a, 'address'),
          value: a,
        })
      })

      return [].concat(
        optionHosType,
        optionHosLevel,
        optionHosTag,
        optionYear,
        optionStart,
        opitonEnd,
        optionDemostic,
        optionKeyWord,
        optionAddressId
      )
    },
  },
  methods: {
    /**
     * 获取列表
     */
    async getEntityList() {
      this.params.sort_type = this.sort_id
      this.params.user_key = this.user_key
      if (this.params.s_time) {
        this.params.s_time = moment(this.params.s_time).format('YYYY-MM-DD')
      }
      if (this.params.e_time) {
        this.params.e_time = moment(this.params.e_time).format('YYYY-MM-DD')
      }
      this.listLoading = true
      let res = await hospitalList(this.params, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        this.$set(this.$data, 'listData', res.res)
        // this.$set(this.$data, 'total', res.count)
        if (this.params.page == 1) {
          this.$set(this.$data, 'total', res.count)
        }
        this.listLoading = false
      } else {
        this.$Message.error(res.message)
      }
    },
    /**
     * 清空已选择项
     */
    handleClearOption() {
      this.params = {
        hos_type: [],
        hos_level: [],
        hos_tag: [],
        demostic: null,
        address_id: [],
        year: '',
        s_time: '',
        e_time: '',
        page: 1,
        user_key: '',
        keyword: '',
      }
      this.checkAll = {
        hos_type: true,
        hos_level: true,
        hos_tag: true,
      }
      this.selTime = ''
      this.search_ipt = ''
      this.params.page = 1
      this.getEntityList()
    },
    /**
     * 筛选个数
     */
    async getCount() {
      let res = await hospitalNum((error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        this.$set(this.$data, 'chinaNum', res.china)
        this.$set(this.$data, 'foreignNum', res.foreign)
        this.$set(this.$data, 'provinceNum', res.province)
        this.$set(this.$data, 'yearNum', res.year)
        this.$set(this.$data, 'levelNum', res.level)
        this.$set(this.$data, 'typeNum', res.type)
        this.$set(this.$data, 'tagNum', res.tag)
      } else {
        this.$Message.error(res.message)
      }
    },
  },
  created() {
    if (this.$store.state.hospital_params != '') {
      this.params = { ...this.$store.state.hospital_params }
      this.params.page = 1
      this.sort_id = this.params.sort_type
    }
    this.getEntityList()
    this.getCount()
  },
  mounted() {
    this.$nextTick(() => {
      window.onscroll = () => {
        this.listenerScroll('right_column', 10)
      }
      window.onresize = () => {
        this.listenerScroll('right_column', 10)
      }
    })
  },
  destroyed() {
    window.onscroll = ''
    window.onresize = ''
  },
  beforeDestroy() {
    this.$store.commit('updateHospitalParams', this.params)
  },
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
@import '~styles/dataList.stylus'
</style>
